export default __webpack_public_path__ + "media/images/raty/smiley/2-06dc9d03fa7fe763f4c418e23eb64513.png";